<div class="bloco-card">
  <div class="bloco-topo">
   <div class="bloco-topo-info">
      <span class="bloco-icone">
        <mat-icon aria-hidden="true">bookmark</mat-icon>
      </span>
      <div class="bloco-textos">
        <h3 class="bloco-title">Buscas salvas</h3>
        <p class="bloco-sub">Retome suas buscas de obras e empresas</p>
      </div>
    </div>
      <div class="filtro-origem" *ngIf="totalEmpresa > 0" role="group" aria-label="Filtrar buscas por origem">
    <button
      type="button"
      class="filtro-opcao"
      [class.ativo]="filtro === 'todas'"
      (click)="selecionarFiltro('todas')"
    >
      Todas
    </button>
    <button
      type="button"
      class="filtro-opcao"
      [class.ativo]="filtro === 'obra'"
      (click)="selecionarFiltro('obra')"
    >
      Obras
    </button>
    <button
      type="button"
      class="filtro-opcao"
      [class.ativo]="filtro === 'empresa'"
      (click)="selecionarFiltro('empresa')"
    >
      Empresas
    </button>
  </div>
    <!-- <div class="bloco-acoes">
      <a [routerLink]="rotaVerTodas" class="btn-outline">Ver todas</a>
    </div> -->
  </div>

  <div class="bloco-content">
    <ng-container *ngIf="!loading; else skeleton">
      <div
        class="search-item"
        *ngFor="let search of searches"
        (click)="abrirBusca(search)"
      >
        <div class="search-icone" [class.search-icone--empresa]="search.origem === 'empresa'">
          <mat-icon aria-hidden="true">{{ search.origem === 'empresa' ? 'business' : 'search' }}</mat-icon>
        </div>
        <div class="search-mid">
          <span class="search-name">{{ search.nome || '(sem nome)' }}</span>
          <span class="search-date">
            Atualizada em {{ search.updatedAt || '-' }}
          </span>
        </div>
        <span class="search-origem" [class.search-origem--empresa]="search.origem === 'empresa'">
          {{ search.origem === 'empresa' ? 'Empresa' : 'Obra' }}
        </span>
      </div>

      <div class="feedback-card" *ngIf="searches.length === 0">
         <mat-icon>bookmark_border</mat-icon>
        <span>Nenhuma busca salva encontrada.</span>
      </div>
    </ng-container>

    <ng-template #skeleton>
      <div class="skeleton">
        <div class="skeleton-item" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="skeleton-icon"></div>
          <div class="skeleton-line"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>